import React from 'react';
import classNames from 'classnames';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".input__input__7-34-0 {\r\n  position: relative;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n  -webkit-box-align: start;\r\n      -ms-flex-align: start;\r\n          align-items: flex-start;\r\n  font-size: 13px;\r\n  padding: 0 8px;\r\n  height: 0;\r\n  min-height: 24px;\r\n  border-radius: 3px;\r\n  border: 1px solid rgba(64, 66, 73, 0.2);\r\n  -webkit-box-shadow: 0 0 0 3px transparent;\r\n          box-shadow: 0 0 0 3px transparent;\r\n  -webkit-transition: border 0.1s, -webkit-box-shadow 0.1s;\r\n  transition: border 0.1s, -webkit-box-shadow 0.1s;\r\n  transition: border 0.1s, box-shadow 0.1s;\r\n  transition: border 0.1s, box-shadow 0.1s, -webkit-box-shadow 0.1s;\r\n  background: #FFFFFF;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n}\r\n.input__input__7-34-0 input:-webkit-autofill,\r\n  .input__input__7-34-0 input:-webkit-autofill:hover,\r\n  .input__input__7-34-0 input:-webkit-autofill:focus,\r\n  .input__input__7-34-0 textarea:-webkit-autofill,\r\n  .input__input__7-34-0 textarea:-webkit-autofill:hover,\r\n  .input__input__7-34-0 textarea:-webkit-autofill:focus {\r\n    /* Change background color for webkit autocomplete */\r\n    -webkit-box-shadow: 0 0 0 1000px #FFFFFF inset;\r\n  }\r\n.input__mask-container__input__7-34-0 {\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 auto;\r\n            flex: 1 1 auto;\r\n    -ms-flex-item-align: stretch;\r\n        -ms-grid-row-align: stretch;\r\n        align-self: stretch;\r\n    position: relative;\r\n    overflow: hidden;\r\n  }\r\n.input--textarea__input__7-34-0 {\r\n    height: auto;\r\n  }\r\n.input--textarea__input__7-34-0 .input__left__input__7-34-0,\r\n    .input--textarea__input__7-34-0 .input__right__input__7-34-0 {\r\n      padding-top: 4px;\r\n      -ms-flex-item-align: start;\r\n          align-self: flex-start;\r\n      -webkit-box-align: start;\r\n          -ms-flex-align: start;\r\n              align-items: flex-start;\r\n    }\r\n.input--textarea__input__7-34-0 .input__mask__input__7-34-0 {\r\n      height: auto;\r\n      display: block;\r\n      padding: 4px 0;\r\n    }\r\n.input--textarea__input__7-34-0 .input__mask__text__input__7-34-0,\r\n      .input--textarea__input__7-34-0 .input__mask__autosuggest__input__7-34-0 {\r\n        display: inline;\r\n        line-height: 16px;\r\n      }\r\n.input--textarea__input__7-34-0 .input__input__input__7-34-0,\r\n    .input--textarea__input__7-34-0 .input__mask-container__input__7-34-0 {\r\n      line-height: 16px;\r\n    }\r\n.input--textarea__input__7-34-0 .input__input__input__7-34-0 {\r\n      padding: 4px 0;\r\n      overflow: hidden;\r\n      -ms-overflow-style: none;\r\n    }\r\n.input__mask__input__7-34-0 {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    word-wrap: break-word;\r\n    pointer-events: none;\r\n    white-space: pre-wrap;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 1;\r\n        -ms-flex: 1 1 auto;\r\n            flex: 1 1 auto;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n  }\r\n.input__mask__text__input__7-34-0 {\r\n      display: -webkit-inline-box;\r\n      display: -ms-inline-flexbox;\r\n      display: inline-flex;\r\n      visibility: hidden;\r\n      height: 100%;\r\n      line-height: 24px;\r\n    }\r\n.input__mask__autosuggest__input__7-34-0 {\r\n      display: -webkit-inline-box;\r\n      display: -ms-inline-flexbox;\r\n      display: inline-flex;\r\n      -webkit-box-align: center;\r\n          -ms-flex-align: center;\r\n              align-items: center;\r\n      height: 100%;\r\n      color: rgba(0, 0, 0, 0.4);\r\n      line-height: 24px;\r\n    }\r\n.input--disable-edit__input__7-34-0 .input__input__input__7-34-0 {\r\n      color: transparent;\r\n      text-shadow: 0 0 0 #000000;\r\n    }\r\n.input--disable-edit__input__7-34-0 .input__input__input__7-34-0:empty {\r\n      text-shadow: 0 0 0 rgba(0, 0, 0, 0.7);\r\n    }\r\n.input__input__input__7-34-0 {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n    outline: none;\r\n    font-size: 13px;\r\n    background: transparent;\r\n    font-family: inherit;\r\n    color: #000000;\r\n    resize: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    display: block;\r\n    overflow-x: hidden;\r\n  }\r\n.input__input__input__7-34-0[readonly] {\r\n      color: rgba(0, 0, 0, 0.4);\r\n    }\r\n.input__input__input__7-34-0[disabled] {\r\n      opacity: 0.5;\r\n      cursor: default;\r\n    }\r\n.input__input__input__7-34-0:-moz-placeholder {\r\n      color: rgba(0, 0, 0, 0.7);\r\n    }\r\n.input__input__input__7-34-0::-webkit-input-placeholder {\r\n      color: rgba(0, 0, 0, 0.7);\r\n    }\r\n.input__input__input__7-34-0:-ms-input-placeholder {\r\n      color: rgba(0, 0, 0, 0.7);\r\n    }\r\n.input__input__input__7-34-0::-ms-clear {\r\n      display: none;\r\n    }\r\n.input__left__input__7-34-0,\r\n  .input__right__input__7-34-0 {\r\n    min-height: 0;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-flex: 0;\r\n        -ms-flex: 0 0 auto;\r\n            flex: 0 0 auto;\r\n    -ms-flex-item-align: stretch;\r\n        align-self: stretch;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n  }\r\n.input__left__input__7-34-0 {\r\n    margin-right: 4px;\r\n    margin-left: -4px;\r\n  }\r\n.input__right__input__7-34-0 {\r\n    margin-left: 4px;\r\n    margin-right: -4px;\r\n  }\r\n.input__input__7-34-0.input--dark__input__7-34-0 {\r\n    background-color: #F5F6F6;\r\n    border-color: #F5F6F6;\r\n  }\r\n.input__input__7-34-0.input--error__input__7-34-0 {\r\n    border-color: #AE304A;\r\n    color: #AE304A;\r\n    -webkit-box-shadow: 0 0 0 3px rgba(174, 48, 74, 0.4);\r\n            box-shadow: 0 0 0 3px rgba(174, 48, 74, 0.4);\r\n  }\r\n.input__input__7-34-0.input--error__input__7-34-0 .input__input__input__7-34-0:-moz-placeholder {\r\n        color: #AE304A;\r\n      }\r\n.input__input__7-34-0.input--error__input__7-34-0 .input__input__input__7-34-0::-webkit-input-placeholder {\r\n        color: #AE304A;\r\n      }\r\n.input__input__7-34-0.input--error__input__7-34-0 .input__input__input__7-34-0:-ms-input-placeholder {\r\n        color: #AE304A;\r\n      }\r\n.input__input__7-34-0.input--warning__input__7-34-0 {\r\n    border-color: #E6961E;\r\n    -webkit-box-shadow: 0 0 0 3px rgba(252, 245, 219, 0.2);\r\n            box-shadow: 0 0 0 3px rgba(252, 245, 219, 0.2);\r\n  }\r\n.input__input__7-34-0.input--success__input__7-34-0 {\r\n    border-color: #60A554;\r\n    -webkit-box-shadow: 0 0 0 3px rgba(96, 165, 84, 0.2);\r\n            box-shadow: 0 0 0 3px rgba(96, 165, 84, 0.2);\r\n  }\r\n.input__input__7-34-0.input--focus__input__7-34-0 {\r\n    border-color: #007EFF;\r\n    -webkit-box-shadow: 0 0 0 3px rgba(0, 126, 255, 0.2);\r\n            box-shadow: 0 0 0 3px rgba(0, 126, 255, 0.2);\r\n  }\r\n.input__input__7-34-0.input--large__input__7-34-0 {\r\n    padding: 0 12px;\r\n    min-height: 32px;\r\n  }\r\n.input__input__7-34-0.input--large__input__7-34-0 .input__left__input__7-34-0 {\r\n      min-height: 0;\r\n      margin-right: 8px;\r\n    }\r\n.input__input__7-34-0.input--large__input__7-34-0 .input__right__input__7-34-0 {\r\n      min-height: 0;\r\n      margin-left: 8px;\r\n    }\r\n.input__input__7-34-0.input--extra-large__input__7-34-0 {\r\n    padding: 0 12px;\r\n    font-size: 16px;\r\n    min-height: 40px;\r\n  }\r\n.input__input__7-34-0.input--extra-large__input__7-34-0 .input__input__input__7-34-0,\r\n    .input__input__7-34-0.input--extra-large__input__7-34-0 .input__mask__input__7-34-0 {\r\n      font-size: 16px;\r\n    }\r\n.input__input__7-34-0.input--extra-large__input__7-34-0 .input__left__input__7-34-0,\r\n    .input__input__7-34-0.input--extra-large__input__7-34-0 .input__right__input__7-34-0 {\r\n      min-height: 0;\r\n    }\r\n.input__error__input__7-34-0 {\r\n    display: none;\r\n    position: absolute;\r\n    bottom: -21px;\r\n    font-size: 13px;\r\n    line-height: 16px;\r\n  }\r\n.input__error--warning__input__7-34-0,\r\n    .input__error--error__input__7-34-0 {\r\n      display: inline-block;\r\n    }\r\n.input__error--warning__input__7-34-0 {\r\n      color: #E6961E;\r\n    }\r\n.input__error--error__input__7-34-0 {\r\n      color: #AE304A;\r\n    }\r\n";
var styles = {"input":"input__input__7-34-0","input__mask-container":"input__mask-container__input__7-34-0","input--textarea":"input--textarea__input__7-34-0","input__left":"input__left__input__7-34-0","input__right":"input__right__input__7-34-0","input__mask":"input__mask__input__7-34-0","input__mask__text":"input__mask__text__input__7-34-0","input__mask__autosuggest":"input__mask__autosuggest__input__7-34-0","input__input":"input__input__input__7-34-0","input--disable-edit":"input--disable-edit__input__7-34-0","input--dark":"input--dark__input__7-34-0","input--error":"input--error__input__7-34-0","input--warning":"input--warning__input__7-34-0","input--success":"input--success__input__7-34-0","input--focus":"input--focus__input__7-34-0","input--large":"input--large__input__7-34-0","input--extra-large":"input--extra-large__input__7-34-0","input__error":"input__error__input__7-34-0","input__error--warning":"input__error--warning__input__7-34-0","input__error--error":"input__error--error__input__7-34-0"};
styleInject(css);

var _sizesClassMapping, _kindsClassMapping;
var InputSizes = {
  "default": 'default',
  L: 'L',
  XL: 'XL'
};
var sizesClassMapping = (_sizesClassMapping = {}, _defineProperty(_sizesClassMapping, InputSizes["default"], undefined), _defineProperty(_sizesClassMapping, InputSizes.L, 'input--large'), _defineProperty(_sizesClassMapping, InputSizes.XL, 'input--extra-large'), _sizesClassMapping);
var InputKinds = {
  "default": 'default',
  success: 'success',
  warning: 'warning',
  error: 'error'
};
var kindsClassMapping = (_kindsClassMapping = {}, _defineProperty(_kindsClassMapping, InputKinds["default"], undefined), _defineProperty(_kindsClassMapping, InputKinds.success, 'input--success'), _defineProperty(_kindsClassMapping, InputKinds.warning, 'input--warning'), _defineProperty(_kindsClassMapping, InputKinds.error, 'input--error'), _kindsClassMapping);
var errorClassMapping = {
  warning: 'input__error--warning',
  error: 'input__error--error'
};
var Types = {
  textarea: 'textarea',
  number: 'number',
  password: 'password',
  "default": 'text'
};
var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).apply(this, arguments));
    _this.maskElement = null;
    _this.inputContainerRef = null;
    _this.mouseDownWithinComponent = false;
    _this.inputElementRef = null;
    _this.state = {
      focus: false,
      textareaLines: 1
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          type = _this$props.type,
          autosuggestText = _this$props.autosuggestText,
          text = _this$props.text,
          onTextChanged = _this$props.onTextChanged,
          allowNewline = _this$props.allowNewline; // To fill the input box with suggested value

      if (event.key === 'ArrowRight' && type === 'default' && Boolean(autosuggestText)) {
        onTextChanged(text + autosuggestText, event);
      }

      if (onKeyDown) {
        onKeyDown(event);
        return;
      }

      if (allowNewline || type !== 'textarea') {
        return;
      }

      if (event.key === 'Enter') {
        event.preventDefault();
      }
    };

    return _this;
  }

  _createClass(Input, [{
    key: "adjustHeight",
    value: function adjustHeight() {
      if (this.props.type !== 'textarea' || this.props.lines || !this.maskElement) {
        return;
      }

      var lineHeight = parseInt(window.getComputedStyle(this.maskElement)['line-height']);
      var numberOfLines = Math.floor(this.maskElement.clientHeight / lineHeight);

      if (this.props.minLines && numberOfLines < this.props.minLines) {
        numberOfLines = this.props.minLines;
      }

      if (this.props.maxLines && numberOfLines > this.props.maxLines) {
        numberOfLines = this.props.maxLines;
      }

      this.setState({
        textareaLines: numberOfLines
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.adjustHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var _this2 = this;

      if (['text', 'type', 'lines', 'size', 'minLines', 'maxLines'].some(function (propName) {
        return _this2.props[propName] !== previousProps[propName];
      })) {
        this.adjustHeight();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // allowNewline, minLines and maxLines are unused in render
      // but are destructured here to remove them from otherProps

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          text = _a.text,
          defaultText = _a.defaultText,
          _a$placeholder = _a.placeholder,
          placeholder = _a$placeholder === void 0 ? '' : _a$placeholder,
          message = _a.message,
          _a$disabled = _a.disabled,
          disabled = _a$disabled === void 0 ? false : _a$disabled,
          _a$readOnly = _a.readOnly,
          readOnly = _a$readOnly === void 0 ? false : _a$readOnly,
          _a$autoFocus = _a.autoFocus,
          autoFocus = _a$autoFocus === void 0 ? this.props.autoFocus : _a$autoFocus,
          _a$disableEdit = _a.disableEdit,
          disableEdit = _a$disableEdit === void 0 ? false : _a$disableEdit,
          _a$isDark = _a.isDark,
          isDark = _a$isDark === void 0 ? false : _a$isDark,
          _a$onTextChanged = _a.onTextChanged,
          onTextChanged = _a$onTextChanged === void 0 ? function () {} : _a$onTextChanged,
          type = _a.type,
          leftElement = _a.leftElement,
          rightElement = _a.rightElement,
          size = _a.size,
          kind = _a.kind,
          autosuggestText = _a.autosuggestText,
          className = _a.className,
          controlClassName = _a.controlClassName,
          lines = _a.lines,
          name = _a.name,
          maxLines = _a.maxLines,
          minLines = _a.minLines,
          allowNewline = _a.allowNewline,
          delayBlurUntilTransition = _a.delayBlurUntilTransition,
          otherProps = __rest(_a, ["text", "defaultText", "placeholder", "message", "disabled", "readOnly", "autoFocus", "disableEdit", "isDark", "onTextChanged", "type", "leftElement", "rightElement", "size", "kind", "autosuggestText", "className", "controlClassName", "lines", "name", "maxLines", "minLines", "allowNewline", "delayBlurUntilTransition"]);

      return React.createElement("div", {
        className: classNames(styles.input, styles[sizesClassMapping[size]], styles[kindsClassMapping[kind]], isDark && styles['input--dark'], type === 'textarea' && styles['input--textarea'], type === 'password' && styles['input--password'], disableEdit && styles['input--disable-edit'], this.state.focus && styles['input--focus'], className),
        ref: function ref(element) {
          return _this3.inputContainerRef = element;
        },
        onMouseDown: function onMouseDown() {
          return _this3.mouseDownWithinComponent = true;
        },
        onMouseUp: function onMouseUp() {
          return _this3.mouseDownWithinComponent = false;
        },
        onMouseLeave: function onMouseLeave() {
          return _this3.mouseDownWithinComponent = false;
        },
        onClick: function onClick() {
          if (_this3.inputElementRef) {
            _this3.inputElementRef.focus();
          }
        },
        onTransitionEnd: function onTransitionEnd() {
          if (delayBlurUntilTransition && _this3.props.onBlur) {
            _this3.props.onBlur(null);
          }
        }
      }, leftElement && React.createElement("span", {
        className: styles.input__left
      }, leftElement), React.createElement("div", {
        className: styles['input__mask-container']
      }, React.createElement("div", {
        className: classNames(styles.input__mask, type === 'textarea' && styles['input__mask-container--textarea']),
        ref: function ref(element) {
          return _this3.maskElement = element;
        }
      }, React.createElement("div", {
        className: styles.input__mask__text
      }, text || placeholder), React.createElement("div", {
        className: styles.input__mask__autosuggest
      }, autosuggestText)), React.createElement(type === 'textarea' ? 'textarea' : 'input', Object.assign({}, otherProps, {
        ref: function ref(element) {
          return _this3.inputElementRef = element;
        },
        type: Types[type] || Types["default"],
        name: name,
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        defaultValue: defaultText,
        value: text === undefined && defaultText === undefined ? '' : text,
        onChange: function onChange(event) {
          return !disableEdit && onTextChanged(event.target['value'], event);
        },
        className: classNames(styles.input__input, controlClassName),
        onFocus: function onFocus(event) {
          if (_this3.state.focus) {
            return;
          }

          _this3.setState({
            focus: true
          });

          if (_this3.props.onFocus) {
            _this3.props.onFocus(event);
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.mouseDownWithinComponent) {
            return;
          }

          _this3.setState({
            focus: false
          });

          if (!delayBlurUntilTransition) {
            _this3.props.onBlur(event);
          }
        },
        onKeyDown: this.handleKeyDown,
        rows: lines || this.state.textareaLines
      }))), rightElement && React.createElement("span", {
        className: styles.input__right
      }, rightElement), React.createElement("div", {
        className: classNames(styles.input__error, styles[errorClassMapping[kind]])
      }, message));
    }
  }]);

  return Input;
}(React.Component);
Input.Sizes = InputSizes;
Input.Kinds = InputKinds;
Input.defaultProps = {
  disabled: false,
  readOnly: false,
  isDark: false,
  onTextChanged: function onTextChanged() {},
  type: 'default',
  kind: 'default',
  size: 'default',
  allowNewline: false,
  message: '',
  minLines: 1,
  maxLines: 3
};

export { Input };
